// extracted by mini-css-extract-plugin
export var actionText = "_o4-4";
export var container = "_o4-0";
export var leftSection = "_o4-1";
export var rightSection = "_o4-2";
export var settingsButton = "_o4-6";
export var settingsIcon = "_o4-7";
export var shortcut = "_o4-5";
export var shortcutGroup = "_o4-3";